import { FormGroup, FormControl, Validators } from '@angular/forms';
import { CustomValidators } from '../../validators/custom-validators.validators';
import { FormulaireCoordonneesMouvementTelephoneModel } from './formulaire-coordonnees-mouvement-telephone.model';
import { TelephoneTypeEnum } from 'src/app/constantes/telephone-type.enum';
import { TelephoneMouvement } from 'src/app/api/model/telephone-mouvement.model';

export class FormulaireCoordonneesMouvementTelephoneBuilder {
  static buildTelephone(
    telephone: TelephoneMouvement | null,
  ): FormGroup<FormulaireCoordonneesMouvementTelephoneModel> {
    return new FormGroup<FormulaireCoordonneesMouvementTelephoneModel>({
      numeroTelephone: new FormControl<string>(telephone?.numeroTelephone || '', {
        nonNullable: true,
        validators: [Validators.required, CustomValidators.telephoneNombreNonRepete],
      }),
      numeroPoste: new FormControl<string | null>(telephone?.numeroPoste || null, [
        Validators.maxLength(4),
      ]),
      typeAppareil: new FormControl<TelephoneTypeEnum | null>(
        TelephoneTypeEnum[telephone?.typeAppareil as keyof typeof TelephoneTypeEnum] || null,
        [Validators.required],
      ),
      telephoneExistant: new FormControl<boolean>(
        telephone && telephone?.numeroTelephone !== '' ? true : false,
        {
          nonNullable: true,
        },
      ),
    });
  }
}
